import { memo } from 'react';

const WarningCircle = ({ className }) => {
    return (
      <span className={className}>
         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#FF7171"/>
            <path d="M13.608 7.11364L13.3864 15.2614H11.3068L11.0795 7.11364H13.608ZM12.3466 18.8977C11.9716 18.8977 11.6496 18.7652 11.3807 18.5C11.1117 18.2311 10.9792 17.9091 10.983 17.5341C10.9792 17.1629 11.1117 16.8447 11.3807 16.5795C11.6496 16.3144 11.9716 16.1818 12.3466 16.1818C12.7064 16.1818 13.0227 16.3144 13.2955 16.5795C13.5682 16.8447 13.7064 17.1629 13.7102 17.5341C13.7064 17.7841 13.6402 18.0133 13.5114 18.2216C13.3864 18.4261 13.2216 18.5909 13.017 18.7159C12.8125 18.8371 12.589 18.8977 12.3466 18.8977Z" fill="white"/>
         </svg>
      </span>
    );
};

export default WarningCircle;
